<template>
	<Transition name="fade">
		<div v-if="visible" class="fixed inset-0 bg-[#4C4C4C]/40 z-backdrop backdrop-blur-xs" aria-hidden="true" @click="close" />
	</Transition>
</template>

<script setup lang="ts">
	type Props = {
		visible: boolean
	};

	const props = defineProps<Props>();

	const vModelVisible = useVModel(props, 'visible');
	const isScrollLocked = useBodyScrollLock();

	onKeyStroke('Escape', close);

	watch(vModelVisible, (newValue) => {
		isScrollLocked.value = newValue;
	}, {immediate: true});

	function close() {
		vModelVisible.value = false;
	}
</script>
